import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

const plugin = {
    init(Vue, options) {
        if (options.sentry.SENTRY_ENABLE) {

            Sentry.init({
                release: options.sentry.RELEASE,
                dsn: options.sentry.SENTRY_ADDRESS,
                integrations: [new Integrations.Vue({ Vue, attachProps: true })],
                environment: options.env
            });
            Sentry.configureScope((scope) => {
                scope.setExtras(options);
            });
            Vue.prototype.$sentry = Sentry
            Vue.sentry = Sentry
            
            // 主动发送sentry
            Vue.sendSentry = (err, extras) => {
                Vue.sentry.withScope(scope => {
                    extras && Object.keys(extras).length && scope.setExtras(extras);
                    Vue.sentry.captureException(err);
                });
            }
        } else {
            Vue.prototype.$sentry = null
            Vue.sentry = null
        }
    },
    $sentry: Sentry,
}

export default plugin
export const sentryPlugin = plugin.init